function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import * as COLORS from '../../theme/colors';
import * as SCALE from '../../theme/scale';
import { CardContent, Wrapper } from '../card';
const ColorBarWrapper = styled(Wrapper)`
  flex-direction: row;
`;
const ColorBar = styled.div`
  width: 8px;
  background: ${({
  color
}) => COLORS[color]};
  border-radius: ${SCALE.size4} 0 0 ${SCALE.size4};
`;
export const ColorBarCard = /*#__PURE__*/forwardRef(({
  color = 'primary600',
  width,
  elevation,
  outline,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(ColorBarWrapper, {
    ref: ref,
    width,
    elevation,
    outline
  }, /*#__PURE__*/React.createElement(ColorBar, {
    color
  }), /*#__PURE__*/React.createElement(CardContent, _extends({
    titleColor: color,
    width: '100%'
  }, props)));
});
export default ColorBarCard;
//# sourceMappingURL=index.js.map